function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_3824)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_3824",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4718 6.13807L10.529 5.19525L7.33371 8.39052L5.80512 6.86192L4.8623 7.80472L7.33371 10.2761L11.4718 6.13807Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.33332L8 0.666656L14 3.33332V8.66666C14 13.3333 8 15.3333 8 15.3333C8 15.3333 2 13.3333 2 8.66666V3.33332ZM8 13.9045C8.1094 13.8586 8.23647 13.8032 8.37733 13.7379C8.88667 13.5021 9.55733 13.1472 10.2193 12.6691C11.5796 11.6867 12.6667 10.368 12.6667 8.66666V4.19982L8 2.12575L3.33333 4.19982V8.66666C3.33333 10.368 4.42041 11.6867 5.78065 12.6691C6.44269 13.1472 7.11333 13.5021 7.62267 13.7379C7.76353 13.8032 7.8906 13.8586 8 13.9045Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_3824)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#176539",
    style: {
      fill: "#176539",
      fill: "color(display-p3 0.0902 0.3961 0.2235)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_3824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafe);
export default __webpack_public_path__ + "static/media/safe.671da5de0bd3db0072c2c20aea4f064f.svg";
export { ForwardRef as ReactComponent };